<template>
  <div class="details-sub-tabs-traces">
    <div
      v-if="disputeTraces && disputeTraces.length && showRetryButton()"
      class="details-sub-tabs-traces__header">
      <Button
        label="Retry Failure Trace"
        class="details-sub-tabs-traces__header__button"
        appearance="secondary"
        :disabled="disableRetryButton"
        @onClick="onButtonClick()" />
    </div>
    <div class="details-sub-tabs-traces-table" :class="tableParentClass">
      <Table
        :default-columns="disputeTracesSapColumns"
        :row-data="disputeTraces"
        primary-key="ohpDisputeTraceId"
        cell-background="#fff"
        header-cell-background="#f7f7f7"
        no-data-message="Dispute Trace Data is not Present"
        @addParentClass="addParentClass">
      </Table>
    </div>
  </div>
</template>

<script>
// // Components
import { disputeActions } from "@/actions";
import AxiosFetchForMsal from "@/utils/axiosForMsal";

// Helpers
import { getMsalIdToken } from "@/utils/helpers.js";

// Constants
import { disputeTracesSapColumns } from "@/config/constant.js";

export default {
  name: "DisputeTraces",
  props: {
    disputeTraces: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      disputeTracesSapColumns,
      showingClipboardToast: false,
      tableParentClass: "",
      retryTraceDispute: {},
      disableRetryButton: false,
    };
  },
  methods: {
    addParentClass(val) {
      this.tableParentClass = val;
    },
    showRetryButton() {
      this.retryTraceDispute = this.disputeTraces?.find(
        (disputeTrace) => disputeTrace?.status !== "Success"
      );
      return this.retryTraceDispute || false;
    },
    async onButtonClick() {
      try {
        await AxiosFetchForMsal(
          disputeActions.getDisputeTraceRetry(
            this.retryTraceDispute?.workflowInstanceId,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        this.disableRetryButton = true;
        this.$emit("startTracesPolling");
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss">
.details-sub-tabs-traces {
  .table-parent-style {
    overflow: auto;
  }
}
</style>

<style lang="scss">
.details-sub-tabs-traces {
  .table-parent-style {
    overflow: auto;
  }
  &__header {
    padding-bottom: 16px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 16px;
  }
  .pointer {
    cursor: pointer;
  }
}
</style>
